
import { createReducer, on, Action } from '@ngrx/store';
import {
    onNgrxForms, onNgrxFormsAction, SetValueAction
} from 'ngrx-forms';
import { IPersonalDetailsState } from './state';
import { PersonalDetailsResponseAction } from './actions';


export const defaultPersonalDetailsState: IPersonalDetailsState = {
    wording: null
};

const reducer = createReducer(defaultPersonalDetailsState,
    onNgrxForms(),
    onNgrxFormsAction(SetValueAction, (state, action) => {
        return state;
    }),
    on(PersonalDetailsResponseAction, (state, { wording }) => {
        return {
            ...state,
            wording
        }
    })
);

export function personalDetailsReducer(state: any | undefined, action: Action) {
    return reducer(state, action);
}
